import applicationDraftService from "./applicationDraftService";
import applicationSurveyService from "./applicationSurveyService";

const services = [
    ...applicationDraftService,
    ...applicationSurveyService
]

export default services;
export {applicationDraftService, applicationSurveyService};